import Vue from 'vue'
import VueResource from 'vue-resource'
import toastr from '../toastr'
import Moment from 'moment'
import Swal from 'sweetalert2'

if ($('#region_grid_header').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#region_grid_header',
    methods: {
      autoAssign: function() {
        $('#auto_assign').button('loading')
        let url = Routing.generate('api_dispatch_assign_regions_to_addresses_and_update_routes')

        this.$http.post(url, { fromDate: (new Moment()).add(1, 'days').format('YYYY-MM-DD') })
          .then(() => {
            toastr.success(Translator.trans('region.grid.messages.assign_regions_to_addresses_success'))
            $('#auto_assign').button('reset')
          }, response => {
            if (response.status === 425) {
              this.handleAjaxError(response)
            } else {
              toastr.error(Translator.trans('region.grid.messages.auto_assign_error'))
            }
            $('#auto_assign').button('reset')
          })
      },
      downloadAddressReport: function() {
        $('#address_report').button('loading')
        let route = Routing.generate('api_dispatch_region_generate_assigned_address_report')
        this.$http.get(route).then( () => {
          $('#address_report').button('reset')
          Swal.fire({
            title: 'Raport przypisania adresów do rejonów',
            text: 'Zlecono wygenerowanie raportu. Gdy będzie gotowy, otrzymasz maila z linkiem do pobrania.',
            icon: 'success',
            confirmButtonText: 'OK'
          })
        }, response => {
          $('#address_report').button('reset')
          this.handleAjaxError(response)
        })
      },

      downloadAddressReportErrors: function() {
        $('#generate_report').button('loading')
        let route = Routing.generate('api_address_report')
        this.$http.get(route).then( () => {
          $('#generate_report').button('reset')
          Swal.fire({
            title: 'Raport błędnych przypisań rejonów',
            text: 'Zlecono wygenerowanie raportu. Gdy będzie gotowy, otrzymasz maila z linkiem do pobrania.',
            icon: 'success',
            confirmButtonText: 'OK'
          })
        }, response => {
          $('#generate_report').button('reset')
          this.handleAjaxError(response)
        })
      },
    }
  })
}
